import { logger } from 'src/util/logger'

export const STORAGE_KEYS: Record<string, string> = {}

export interface CachedData<T> {
  data: T
}

export const localStorageUtil = {
  getItem: <T>(storageKey: string): CachedData<T> | null => {
    try {
      const cached = localStorage.getItem(storageKey)
      if (!cached) return null

      return JSON.parse(cached)
    } catch (error) {
      logger.warn(`Failed to parse cached data for key "${storageKey}":`, error)
      return null
    }
  },

  setItem: <T>(storageKey: string, data: T): void => {
    try {
      const dataToCache: CachedData<T> = {
        data,
      }

      localStorage.setItem(storageKey, JSON.stringify(dataToCache))
    } catch (error) {
      logger.warn(`Failed to cache data for key "${storageKey}":`, error)
    }
  },

  removeItem: (storageKey: string): void => {
    try {
      localStorage.removeItem(storageKey)
    } catch (error) {
      logger.warn(`Failed to clear cached data for key "${storageKey}":`, error)
    }
  },

  clearAllCachedData: (): void => {
    try {
      Object.values(STORAGE_KEYS).forEach((key) => {
        localStorage.removeItem(key)
      })
    } catch (error) {
      logger.warn('Failed to clear all cached data:', error)
    }
  },
}
